var map = {
	"./asset-hyperlink.json": 5313,
	"./blockquote.json": 8473,
	"./document.json": 683,
	"./embedded-asset-block.json": 6645,
	"./embedded-entry-block.json": 1893,
	"./embedded-entry-inline.json": 4513,
	"./embedded-resource-block.json": 835,
	"./embedded-resource-inline.json": 7131,
	"./entry-hyperlink.json": 9357,
	"./heading-1.json": 406,
	"./heading-2.json": 5095,
	"./heading-3.json": 6052,
	"./heading-4.json": 6997,
	"./heading-5.json": 2618,
	"./heading-6.json": 7291,
	"./hr.json": 6224,
	"./hyperlink.json": 3680,
	"./list-item.json": 3674,
	"./ordered-list.json": 5790,
	"./paragraph.json": 3060,
	"./resource-hyperlink.json": 8141,
	"./table-cell.json": 2897,
	"./table-header-cell.json": 9107,
	"./table-row.json": 43,
	"./table.json": 9401,
	"./text.json": 6753,
	"./unordered-list.json": 481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7937;